// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"TemplateDashboard_dashboard__3itos","title":"TemplateDashboard_title__32_pb","groupContainer":"TemplateDashboard_groupContainer__1_PyO"};